import React from 'react';
import styles from './styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <b>
          <li>PARA PIHAK</li>
        </b>
        <ol type="1">
          <li>
            Pihak-pihak yang tergabung dalam S&amp;K ini adalah:
            <ol type="a">
              <li>
                PT Moka Teknologi Indonesia, untuk selanjutnya disebut sebagai “
                <b>MOKA</b>”;
              </li>
              <li>
                PT Espay Debit Indonesia Koe, untuk selanjutnya disebut sebagai
                “<b>DANA</b>”
              </li>
              <li>
                Merchant, sebagaimana disebutkan dalam Formulir Aplikasi
                Merchant Digital, yang merupakan satu kesatuan dengan S&amp;K
                ini.
              </li>
            </ol>
          </li>
          <li>
            MOKA, DANA, dan Merchant secara bersama-sama untuk selanjutnya
            disebut sebagai “Para Pihak” dan masing-masing disebut sebagai
            “Pihak”.
          </li>
        </ol>
        <b>
          <li>PENGANTAR</li>
        </b>
        Para Pihak terlebih dahulu menerangkan bahwa:
        <ol type="1">
          <li>
            Merchant telah menyetujui Syarat dan Ketentuan penggunaan Aplikasi
            Moka yang ditampilkan pada Aplikasi Moka dan melengkapi Formulir
            Aplikasi Merchant Digital yang tersedia pada Aplikasi Moka;
          </li>
          <li>
            Merchant telah sepakat untuk dapat menerima pembayaran, melalui
            Aplikasi Moka, dari pelanggannya yang melakukan pembayaran dengan
            menggunakan fitur DANA Payment pada Aplikasi DANA; dan
          </li>
          <li>
            oleh karena itu, Merchant wajib, terlebih dahulu, membaca dan
            menyetujui syarat dan ketentuan berikut:
          </li>
        </ol>
        <b>
          <li>DEFINISI DAN INTERPRETASI</li>
        </b>
        <ol type="1">
          <li>
            Jika tidak ditentukan lain secara tegas dalam S&amp;K ini,
            istilah-istilah berikut memiliki arti sebagai berikut:
            <ol type="a">
              <li>
                "<b>Aplikasi DANA</b>" adalah <i>mobile application</i> yang
                memiliki fitur untuk memproses pembayaran secara elektronik yang
                dibuat, dimiliki, dikembangkan, dirancang, disediakan dan
                dikelola oleh DANA.
              </li>
              <li>
                "<b>Aplikasi Moka</b>" adalah aplikasi berbasis mobile yang
                memiliki sistem kasir berbasis <i>cloud</i>. yang dapat
                digunakan Merchant untuk mencatat transaksi pembelian Produknya,
                yang dimiliki, dikembangkan, dirancang, disediakan, dan dikelola
                oleh MOKA dengan nama, logo dan/atau tanda lainnya sebagaimana
                diberitahukan oleh MOKA dari waktu ke waktu.
              </li>
              <li>
                "<b>Keadaan Kahar</b>" adalah segala kejadian yang terjadi di
                luar kemampuan, kendali dan perkiraan Pihak yang mengalami dan
                bukan disebabkan karena kesalahan maupun kelalaian dari Pihak
                tersebut, termasuk namun tidak terbatas pada; pemogokan,
                embargo, huru-hara, pertempuran, peperangan, kebakaran,
                peledakan, sabotase, badai, banjir, gempa bumi, atau
                diberlakukannya peraturan perundang-undangan atau dikeluarkannya
                keputusan dari pihak yang berwenang yang menyebabkan harus
                dihentikannya seluruh atau sebagian pelaksanaan kerjasama
                berdasarkan S&amp;K ini.
              </li>
              <li>
                "<b>Formulir Aplikasi Merchant Digital</b>" atau "
                <b>Formulir</b>" adalah formulir yang wajib diisi oleh Merchant
                untuk dapat menggunakan fitur-fitur yang tersedia pada Aplikasi
                Moka, yang berisikan, data atau informasi Merchant, termasuk
                namun tidak terbatas pada; alamat, perizinan, dan/atau informasi
                perusahaan Merchant, dan nomor rekening bank Merchant.
              </li>
              <li>
                "<b>Hari Kerja</b>" adalah hari kerja mulai dari hari Senin
                sampai Jumat, tidak termasuk Sabtu, Minggu dan hari libur
                nasional yang ditetapkan oleh Pemerintah Republik Indonesia.
              </li>
              <li>
                "<b>Merchant Discount Rate</b>" atau "<b>MDR</b>" adalah biaya
                yang dibebankan kepada Merchant atas penyediaan Layanan oleh
                DANA. MDR diambil dari sejumlah persentase dari nilai Transaksi.
                Besaran persentase yang diambil sebagai MDR untuk setiap
                Transaksi yang berhasil dilakukan jumlahnya adalah 0,7% untuk
                dompet elektronik maupun untuk kartu kredit dari nilai
                Transaksi.
              </li>
              <li>
                "<b>DANA Payment</b>" adalah fitur pembayaran yang dapat diakses
                oleh Pelanggan melalui Aplikasi DANA dimana Pelanggan dapat
                melakukan pembayaran atas Produk dengan menggunakan uang
                elektronik berbasis server dan <i>point rewards</i> yang
                diterbitkan oleh DANA.
              </li>
              <li>
                "<b>Produk</b>" adalah barang dan/atau jasa yang disediakan,
                ditawarkan, dan/atau dijual oleh Merchant kepada Pelanggan.
              </li>
              <li>
                "<b>Transaksi</b>" adalah segala transaksi pembayaran atas
                Produk yang dilakukan oleh Pelanggan dengan menggunakan DANA
                Payment.
              </li>
              <li>
                "<b>Pelanggan</b>" adalah pelanggan-pelanggan Merchant.
              </li>
              <li>
                "<b>Waktu Cut-Off</b>" adalah batas waktu akhir pencatatan
                seluruh Transaksi oleh DANA atas seluruh Transaksi yang
                dilakukan pada suatu hari. Waktu Cut-Off digunakan sebagai dasar
                waktu untuk DANA dalam melakukan pembayaran dana Transaksi
                kepada Merchant dan dalam hal ini Waktu Cut-Off adalah pada
                pukul 23.59 Waktu Indonesia Barat.
              </li>
            </ol>
          </li>
        </ol>
        <b>
          <li>RUANG LINGKUP S&amp;K</li>
        </b>
        <ol type="1">
          <li>
            Merchant dengan ini sepakat untuk menerima setiap Transaksi, melalui
            Aplikasi Moka, yang dilakukan oleh Pelanggan dengan DANA Payment
            melalui Aplikasi DANA, sehingga Merchant dapat menerima Transaksi
            tersebut dan mencatatnya pada Aplikasi Mokanya;
          </li>
          <li>
            MOKA dan Merchant dengan ini sepakat bahwa DANA akan melakukan
            pemrosesan atas setiap Transaksi atas setiap pembayaran Produk yang
            dilakukan dengan DANA Payment dan dicatat oleh Merchant pada
            Aplikasi Moka; dan
          </li>
          <li>
            MOKA dengan ini berjanji untuk melaksanakan penyelesaian atas dana
            Transaksi kepada Merchant atas seluruh Transaksi yang dilakukan
            menggunakan DANA Payment.
          </li>
        </ol>
        <b>
          <li>PERSYARATAN UMUM MERCHANT</li>
        </b>
        <ol type="1">
          <li>
            Untuk dapat menerima Transaksi yang dilakukan menggunakan DANA
            Payment, Merchant wajib untuk:
            <ol type="1">
              <li>
                memiliki aktivitas usaha dan/atau perizinan lengkap yang masih
                berlaku;
              </li>
              <li>memiliki rekening bank yang aktif; dan</li>
              <li>mengisi Formulir dan menyetujui S&amp;K ini.</li>
            </ol>
          </li>
          <li>
            Merchant dengan ini menyatakan bahwa seluruh informasi dan data yang
            diberikan kepada MOKA berdasarkan Fomulir merupakan informasi dan
            data yang sebenar-benarnya dan Merchant bertanggungjawab atas
            seluruh kebenaran informasi dan data tersebut.
          </li>
          <li>
            Merchant dengan ini sepakat bahwa informasi dan data Merchant yang
            diserahkan oleh Merchant kepada MOKA berdasarkan Fomulir akan
            diserahkan oleh MOKA kepada DANA untuk kepentingan pemrosesan
            Transaksi yang dilakukan menggunakan DANA Payment.
          </li>
        </ol>
        <b>
          <li>KEWAJIBAN DAN HAK PARA PIHAK</li>
        </b>
        <ol type="1">
          <li>
            Tanpa mengesampingkan kewajiban-kewajiban Merchant lainnya pada
            S&amp;K ini, Merchant berkewajiban untuk:
            <ol type="a">
              <li>
                menerima setiap Transaksi sesuai dengan tata cara dan ketentuan
                yang ditentukan oleh MOKA, serta tidak diperbolehkan untuk
                menolak ataupun membebankan biaya tambahan kepada Pelanggan
                dalam bentuk apapun untuk pelaksanaan Transaksi;
              </li>
              <li>
                memberikan dan/atau menunjukkan bukti pembayaran kepada
                Pelanggan atas Transaksi yang berhasil dilakukan;
              </li>
              <li>
                memastikan kerahasiaan data atau informasi mengenai Transaksi
                termasuk namun tidak terbatas pada; faktur pembelian dan
                informasi Pelanggan, dan tidak mengungkapkan data atau informasi
                tersebut kepada pihak ketiga lainnya untuk keperluan apapun;
              </li>
              <li>memastikan kebenaran dan keaslian setiap Transaksi;</li>
              <li>
                menyediakan catatan, dokumen atau bukti pendukung, dan/atau
                pembukuan Transaksi secara layak dan akuntabel yang wajib
                ditunjukkan dan/atau diberikan sewaktu-waktu kepada MOKA untuk
                kepentingan verifikasi maupun audit terhadap kebenaran dan
                keaslian Transaksi; dan
              </li>
              <li>
                tidak melakukan Transaksi yang tidak benar/transaksi palsu
                maupun melakukan bentuk perbuatan-perbuatan melanggar hukum
                lainnya dan tidak bekerjasama dengan pelaku kejahatan (
                <i>fraudster</i>) yang dapat menyebabkan kerugian terhadap
                Pelanggan, MOKA, DANA, dan/atau pihak ketiga lainnya.
              </li>
            </ol>
          </li>
          <li>
            Tanpa mengesampingkan hak-hak Merchant lainnya pada S&amp;K ini,
            Merchant berhak untuk:
            <ol type="a">
              <li>
                menerima pembayaran atas dana Transaksi, setelah dikurangi MDR,
                dari MOKA;
              </li>
              <li>
                menerima laporan Transaksi harian dari MOKA atas suatu hari
                paling lambat 2 (dua) Hari Kerja (H+2) sejak Waktu Cut-Off pada
                suatu hari tersebut; dan
              </li>
              <li>
                menerima pembinaan secara berkala dari MOKA terkait dengan
                penerimaan Transaksi, Aplikasi DANA, dan DANA Payment.
              </li>
            </ol>
          </li>
          <li>
            Tanpa mengesampingkan kewajiban-kewajiban MOKA lainnya pada S&amp;K
            ini, MOKA berkewajiban untuk:
            <ol type="a">
              <li>
                membayar dana Transaksi, setelah dikurangi dengan MDR, kepada
                Merchant; dan
              </li>
              <li>
                menyediakan laporan Transaksi harian kepada Merchant atas suatu
                hari paling lambat 2 (dua) Hari Kerja (H+2) sejak Waktu Cut-Off
                pada suatu hari tersebut.
              </li>
            </ol>
          </li>
          <li>
            Tanpa mengesampingkan hak-hak MOKA lainnya pada S&amp;K ini, MOKA
            berhak untuk:
            <ol type="a">
              <li>
                menerima MDR dari Merchant dengan cara memotong langsung dari
                dana Transaksi yang diterima atas setiap Transaksi yang berhasil
                dilakukan;
              </li>
              <li>
                menangguhkan pembayaran atas dana Transaksi kepada Merchant dan
                menerima ganti rugi dari Merchant, dalam hal adanya dugaan atau
                indikasi Transaksi hasil penipuan, Transaksi yang dilakukan
                dengan melanggar hukum, dan/atau Transaksi sebagaimana dimaksud
                dalam Pasal XV S&amp;K ini;
              </li>
              <li>
                melakukan audit maupun verifikasi dengan melihat dan/atau
                memeriksa dan/atau meminta catatan, dokumen atau bukti
                pendukung, dan/atau pembukuan Transaksi dari pihak Merchant; dan
              </li>
              <li>
                melakukan upaya hukum yang dianggap perlu atas terjadinya
                keadaan sebagaimana dimaksud dalam Pasal XV S&amp;K ini.
              </li>
            </ol>
          </li>
          <li>
            Tanpa mengesampingkan kewajiban-kewajiban DANA lainnya pada S&amp;K
            ini, DANA berkewajiban untuk melakukan pemrosesan atas seluruh
            Transaksi yang dilakukan dengan DANA Payment sehingga Merchant dapat
            menerima Transaksi tersebut.
          </li>
          <li>
            Tanpa mengesampingkan hak-hak DANA lainnya pada S&amp;K ini, DANA
            berhak untuk:
            <ol type="a">
              <li>menentukan tata cara penerimaan Transaksi;</li>
              <li>
                menentukan tata cara pelaksanaan penyelesaian atau pembayaran
                dana Transaksi dari MOKA kepada Merchant; dan
              </li>
              <li>
                menentukan untuk menerima atau menolak pendaftaran Merchant
                sebagai merchant DANA.
              </li>
            </ol>
          </li>
        </ol>
        <b>
          <li>KOREKSI ATAS TRANSAKSI</li>
        </b>
        <ol type="1">
          <li>
            Para Pihak dengan ini sepakat dan menyetujui bahwa perhitungan
            laporan Transaksi harian yang dikeluarkan oleh MOKA adalah
            perhitungan yang menjadi dasar acuan untuk pembayaran dana
            Transaksi.
          </li>
          <li>
            MOKA berhak untuk melakukan koreksi atas Transaksi jika jumlah nilai
            pembayaran ke Merchant oleh MOKA lebih dari atau tidak sesuai dengan
            jumlah yang tertera pada laporan Transaksi harian yang dikeluarkan
            oleh MOKA.
          </li>
          <li>
            Tanpa mengesampingkan ketentuan pada huruf a) di atas, Merchant
            dapat mengajukan sanggahan ke MOKA atas selisih pembayaran disertai
            dengan dokumen pendukung yang dapat diterima oleh MOKA.
          </li>
        </ol>
        <b>
          <li>KETENTUAN PEMBAYARAN</li>
        </b>
        Berdasarkan laporan Transaksi harian yang dikeluarkan oleh MOKA, MOKA
        wajib membayar dana Transaksi, setelah dikurangi dengan MDR, kepada
        Merchant dalam waktu selambat-lambatnya 2 (dua) Hari Kerja sejak Waktu
        Cut-Off terakhir, ke rekening Merchant seperti yang tertera pada
        Formulir.
        <b>
          <li>MASA BERLAKU DAN PENGAKHIRAN</li>
        </b>
        Ketentuan-ketentuan dalam S&K ini mulai berlaku sejak Merchant
        menyetujui S&K ini dengan cara menekan pilihan “Setuju” pada halaman
        dimana S&K ini ditampilkan pada Aplikasi Moka dan S&K ini akan tetap
        berlaku sepanjang kerjasama antara MOKA dan DANA tetap berlaku.
        <b>
          <li>PEMBATASAN TANGGUNG JAWAB</li>
        </b>
        Merchant dengan ini membebaskan DANA dan MOKA dari segala:
        <ol type="a">
          <li>
            tanggungjawab sehubungan dengan Produk yang disediakan atau dijual
            oleh Merchant kepada Pelanggan;
          </li>
          <li>
            kerugian yang timbul dari gangguan pada koneksi internet atau
            jaringan komunikasi sehingga menyebabkan gagalnya Transaksi;
          </li>
          <li>
            tuntutan hukum, gugatan, dan/atau klaim dari Pelanggan dan/atau
            pihak ketiga lainnya terkait dengan kelalaian atau kesalahan
            Merchant dalam melaksanakan kegiatan usahanya;
          </li>
          <li>
            tuntutan hukum, gugatan, dan/atau klaim dari pihak manapun yang
            timbul akibat dari penggunaan atau pengungkapan atas informasi
            Transaksi dan/atau Pelanggan yang dilakukan secara melawan hukum
            atau bertentangan dengan maksud dan tujuan S&K ini; dan/atau
          </li>
          <li>
            risiko yang timbul akibat dari kesalahan informasi dan data yang
            dituliskan oleh Merchant pada Formulir.
          </li>
        </ol>
        <b>
          <li>PENYELESAIAN PERSELISIHAN</li>
        </b>
        <ol type="1">
          <li>
            Para Pihak sepakat dan menyetujui untuk menyelesaikan segala
            perselisihan yang timbul berdasarkan S&amp;K ini secara kekeluargaan
            dan melalui musyawarah untuk mufakat.
          </li>
          <li>
            Apabila Para Pihak gagal menyelesaikan perselisihan tersebut secara
            kekeluargaan dan mencapai kata mufakat maka salah satu Pihak dapat
            mengajukan penyelesaian perselisihan tersebut ke pengadilan yang
            berwenang untuk menyelesaikan perselisihan tersebut. Dengan ini,
            Para Pihak setuju untuk menyelesaikan perselisihan tersebut di
            Pengadilan Negeri Jakarta Selatan.
          </li>
          <li>
            Dikecualikan dari keadaan dan ketentuan ayat a) dan b) tersebut
            diatas, maka MOKA dan/atau DANA sewaktu-waktu dapat melakukan upaya
            hukum secara pidana dan/atau perdata terhadap setiap dugaan
            pelanggaran yang terjadi dalam pelaksanaan S&K ini.
          </li>
        </ol>
        <b>
          <li>PENGGUNAAN NAMA, MEREK DAN LOGO</li>
        </b>
        <ol type="1">
          <li>
            Sesuai yang dipersyaratkan oleh MOKA dan/atau DANA, Merchant wajib
            untuk menampilkan nama, logo, atau tanda lainnya atas merek “DANA”
            atau nama, logo, atau tanda lainnya atas merek lain yang ditentukan
            oleh DANA, sewaktu-waktu, di lokasi usaha Merchant.
          </li>
          <li>
            Merchant wajib memastikan bahwa setiap materi promosi yang diberikan
            oleh MOKA sehubungan dengan penerimaan Transaksi dengan DANA
            Payment, ditampilkan dengan jelas dan terlihat oleh umum, pada
            lokasi-lokasi usaha Merchant;
          </li>
          <li>
            Hak atas kekayaan intelektual yang dimiliki oleh masing-masing Pihak
            tetap menjadi kepemilikan dari Pihak yang bersangkutan. S&amp;K ini
            tidak bermaksud untuk mengalihkan hak atas kekayaan intelektual yang
            dimiliki oleh satu Pihak ke Pihak lainnya.
          </li>
        </ol>
        <b>
          <li>KEADAAN KAHAR</li>
        </b>
        <ol type="1">
          <li>
            Dalam Keadaan Kahar, Pihak yang mengalami Keadaan Kahar tersebut
            wajib memberitahukan secara tertulis kepada Pihak lainnya
            selambat-lambatnya 7 (tujuh) hari kalender sejak terjadinya Keadaan
            Kahar tersebut.
          </li>
          <li>
            Keadaan Kahar dapat dijadikan dasar perpanjangan waktu pelaksanaan
            kewajiban oleh Pihak yang mengalami Keadaan Kahar dan karenanya
            Pihak yang tidak mengalami Keadaan Kahar membebaskan Pihak yang
            mengalami Keadaan Kahar dari sanksi atas keterlambatan dalam
            melaksanakan kewajiban yang semestinya dipenuhi.
          </li>
        </ol>
        <b>
          <li>LAIN-LAIN</li>
        </b>
        <ol type="1">
          <li>
            Merchant menyatakan dan menjamin bahwa semua informasi yang
            dituliskan dalam Formulir adalah benar dan bertanggung jawab penuh
            atas keakuratan informasi tersebut.
          </li>
          <li>
            Masing-masing Pihak tidak dapat mengalihkan sebagian atau seluruh
            hak dan kewajiban yang diatur dalam S&amp;K ini kepada pihak ketiga
            tanpa persetujuan tertulis dari Pihak lainnya.
          </li>
          <li>
            Masing-masing Pihak bertanggung jawab atas segala pajak yang timbul
            atas pelaksanaan S&amp;K ini sesuai dengan ketentuan peraturan
            perundang-undangan yang berlaku.
          </li>
          <li>
            S&amp;K ini berlaku dan mengikat baik bagi Para Pihak maupun bagi
            para penggantinya (penerusnya).
          </li>
          <li>
            S&amp;K ini dibuat dalam dua bahasa yaitu Bahasa Indonesia dan
            Bahasa Inggris, versi Bahasa Inggris hanya berlaku sebagai
            terjemahan atas versi Bahasa Indonesia. Oleh karena itu, dalam hal
            terdapat perbedaan dalam interpretasi antara kedua versi tersebut
            maka versi Bahasa Indonesia yang akan berlaku.
          </li>
        </ol>
        <b>
          <li>PENYALAHGUNAAN TRANSAKSI</li>
        </b>
        <ol type="1">
          <li>
            Merchant bertanggung jawab untuk mencegah setiap Transaksi yang
            dilakukan oleh dan untuk tujuan yang semata-mata menguntungkan
            Merchant, perwakilan, agen, karyawan, atau kontraktor nya ("
            <b>Perwakilan</b>"), maupun terhadap setiap Transaksi yang melanggar
            hukum, atau yang dapat merugikan MOKA dan/atau DANA termasuk tetapi
            tidak terbatas pada; Transaksi yang dilakukan oleh Merchant dan/atau
            Perwakilannya dan/atau orang lain yang bekerja sama dengan Merchant
            di lokasi-lokasi gerainya sendiri atas Produk Merchant sendiri.
          </li>
          <li>
            Dalam hal MOKA dan/atau DANA menemukan atau mencurigai terjadinya
            Transaksi atau penggunaan Aplikasi DANA atau Aplikasi MOKA untuk
            tujuan sebagaimana dimaksud dalam huruf a) di atas maka DANA atau
            MOKA berhak untuk menangguhkan pembayaran dana Transaksi yang
            terindikasi merupakan hasil dari Transaksi sebagaimana dimaksud
            dalam huruf a) di atas kepada Merchant.
          </li>
          <li>
            Merchant dan/atau Perwakilan dilarang untuk melakukan modifikasi
            Perangkat Elektronik dan menggunakan Layanan secara tidak sah, atau
            untuk tujuan yang melanggar hukum, termasuk namun tidak terbatas
            pada; <i>fraud</i> dan Transaksi ilegal lainnya.
          </li>
          <li>
            Dalam hal terjadi peristiwa sebagaimana dimaksud dalam huruf c) di
            atas maka Merchant dan/atau Perwakilan wajib dengan segera
            memberitahukan MOKA atau DANA atas terjadinya peristiwa tersebut.
          </li>
          <li>
            Penangguhan pembayaran dana Transaksi sebagaimana dimaksud pada
            huruf b) akan berlangsung untuk jangka waktu 14 (empat belas) Hari
            Kerja, apabila setelah jangka waktu tersebut terlampaui dan Merchant
            tidak terbukti melakukan pelanggaran atas ketentuan huruf a) di atas
            maka MOKA akan mengakhiri penangguhan tersebut dan membayar dana
            Transaksi yang ditahan kepada Merchant.
          </li>
          <li>
            Dalam hal Merchant terbukti melakukan pelanggaran atas ketentuan
            huruf a) di atas maka MOKA atas kebijakannya sendiri berhak untuk
            menentukan penyelesaian yang dianggap tepat oleh MOKA atas dana
            Transaksi yang ditangguhkan tersebut.
          </li>
          <li>
            Merchant dengan ini membebaskan MOKA dan DANA dari segala tuntutan,
            gugatan, dan/atau klaim dalam hal MOKA menggunakan haknya untuk
            menentukan penyelesaian atas dana Transaksi yang ditahan jika MOKA
            dapat membuktikan, di luar pengadilan, bahwa Merchant telah
            melakukan pelanggaran ketentuan pada huruf a) di atas.
          </li>
        </ol>
        <b>
          <li>PENUTUP</li>
        </b>
        <ol type="1">
          <li>
            Merchant telah membaca, mengerti, dan menyetujui seluruh ketentuan
            dalam S&amp;K ini.
          </li>
          <li>
            Dengan cara menekan pilihan “Setuju” pada halaman dimana S&amp;K ini
            ditampilkan pada Aplikasi Moka maka Merchant berarti telah
            menyetujui seluruh ketentuan dalam S&amp;K ini.
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default Indonesia;
